import { API_BASE, ODATA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import * as moment from "moment";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import {
  optionalInt,
  optionalText,
  optionalUrl,
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import AdSlotGuide from "components/Common/AdSlotGuide";
import { AD_SYSTEM, findSlot, slotNoText } from "helpers/adSlots";
import { stripHtml, truncate } from "helpers/contentUtils";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getAdvertesing_Form as onGetCampain,
  addAdvertesing_Form as onAddCampain,
  updateAdvertesing_Form as onUpdateCampain,
  deleteAdvertesing_Form as onDeleteCampain,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
/** Panelde elle yazilan tip degerleri ("Lotto " gibi) normalize edilir. */
const normalizeType = value =>
  String(value == null ? "" : value).trim().toLocaleLowerCase("tr-TR");

const KNOWN_TYPES = ["döviz", "tatil", "eczane", "imsakiye", "lotto", "map"];

/**
 * Reklam yuksekligi (1/2/3 kutucuk).
 *
 * Asil yer Advertesing_Form_Span kolonu. O kolon API'ye deploy edilene kadar
 * deger, kullanilan MIME tipinin sonuna ";span:N" olarak ekleniyor
 * (ornek: "image/png;span:2"); mobil taraf ikisini de okuyor.
 */
const SPAN_DEFAULT = 2;

const readSpan = row => {
  if (row && row.Advertesing_Form_Span != null) {
    const n = parseInt(row.Advertesing_Form_Span, 10);
    if (!Number.isNaN(n)) return Math.min(Math.max(n, 1), 3);
  }
  const match = /span:(\d+)/.exec(String((row && row.Advertesing_Form_UrlType) || ""));
  const value = match ? parseInt(match[1], 10) : SPAN_DEFAULT;
  return Math.min(Math.max(value || SPAN_DEFAULT, 1), 3);
};

/** ";span:N" ekini atip gercek MIME tipini dondurur. */
const readFileType = row => {
  const raw = String((row && row.Advertesing_Form_UrlType) || "").split(";")[0].trim();
  return raw && !raw.startsWith("span:") ? raw : null;
};

const isVideoType = value => String(value || "").trim().toLowerCase().startsWith("video");

/**
 * Reklama tiklaninca nereye gidilecegini bulur.
 * Mobil uygulamadaki oncelik sirasiyla ayni:
 * link > ozel tip (doviz/tatil/...) > spor > haber > forum > ilan
 */
const describeAdvertTarget = row => {
  const link = String(row.Advertesing_Form_Link || "").trim();
  if (link) return { type: "Dış link", color: "primary", text: link, href: link };

  const type = normalizeType(row.Advertesing_Form_Type);
  if (type) {
    if (KNOWN_TYPES.includes(type)) {
      return { type: "Özel ekran", color: "success", text: type };
    }
    // Taninmayan tip: mobilde hicbir sey yapmaz -> yoneticiye uyari
    return { type: "Geçersiz tip", color: "warning", text: `"${row.Advertesing_Form_Type}" tanınmıyor` };
  }

  if (row.SportCheck) return { type: "Spor", color: "info", text: "Spor sayfası" };
  if (row.News_ID) return { type: "Aktüel", color: "danger", text: stripHtml(row.News && row.News.News_Title) };
  if (row.Forum_ID) return { type: "Forum", color: "secondary", text: stripHtml(row.Forum && row.Forum.Forum_Title) };
  if (row.Job_Advertisement_ID) {
    return { type: "İlan", color: "warning", text: stripHtml(row.Job_Advertisement && row.Job_Advertisement.Job_Advertisement_Title) };
  }

  return { type: "Yönlendirme yok", color: "danger", text: "Tıklanınca hiçbir yere gitmez" };
};

const ContactsList = props => {

  //meta title
  document.title = "Reklam Alanları / Talepler | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');
  // Yuklenen dosyanin MIME tipi ("image/png" / "video/mp4")
  const [getFileType, setFileType] = useState(null);
  // Reklamin kac kutucuk yukseklik kaplayacagi (1/2/3)
  const [getSpan, setSpan] = useState(SPAN_DEFAULT);
  // API'de Advertesing_Form_Span kolonu var mi? ($metadata'dan bir kez ogreniliyor)
  // Kolon yokken bu alan gonderilirse OData 500 doner ve reklam HIC kaydedilmez.
  const [spanSupported, setSpanSupported] = useState(false);


  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);
  const [getIsActive, setIsActive] = useState(false);

  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Advertesing_Form_CompanyName) || "",

      // Reklama tıklanınca açılacak adres (mobilde her yönlendirmeden önce gelir)
      link: (contactEdit && contactEdit.Advertesing_Form_Link) || "",

      discount: (contactEdit && contactEdit.Discount) || "",

      com: (contactEdit && contactEdit.CommissionPercentage) || "",
      maks: (contactEdit && contactEdit.Campain_Maks_Users) || "",
      min: (contactEdit && contactEdit.Campain_MinUsers) || "",
      // NOT: "sort" burada iki kez yaziliydi (ikincisi birincisini eziyordu) -> teke indirildi
      sort: (contactEdit && contactEdit.Sort != null ? contactEdit.Sort : ""),
      type: (contactEdit && contactEdit.Advertesing_Form_Type) || "",
    },
    validationSchema: Yup.object({
      title: requiredText("Firma adı"),
      link: optionalUrl("Reklam linki"),
      sort: optionalInt("Sıralama"),
      type: optionalText("Tip", { max: 100 }),
    }),
    onSubmit: values => {
      const span = parseInt(getSpan, 10) || SPAN_DEFAULT;
      // Kolon henuz yoksa yukseklik MIME tipinin sonuna yedekleniyor
      const urlType = spanSupported
        ? getFileType || null
        : `${getFileType || "image"};span:${span}`;
      const spanFields = spanSupported
        ? { Advertesing_Form_Span: span, Advertesing_Form_UrlType: urlType }
        : { Advertesing_Form_UrlType: urlType };

      // Sira No: kucuk numara once gosterilir, bos birakilirsa reklam
      // numarasizlarin arasinda (en yeni en ustte) kalir.
      // NOT: bu alan formda vardi ama kaydedilmiyordu -> girilen deger hicbir
      // ise yaramiyordu. Artik gonderiliyor (API'de Sort kolonu mevcut).
      const sortValue =
        values.sort === "" || values.sort === null || values.sort === undefined
          ? null
          : parseInt(values.sort, 10);
      const sort = Number.isNaN(sortValue) ? null : sortValue;

      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Advertesing_Form_CompanyName: values.title,
          Advertesing_Category_ID: getCategoryID,
          Advertesing_Form_Type : values.type,
          Advertesing_Form_Image: getFileName,
          Advertesing_Active: getIsActive,
          News_ID:getNewsID,
          Forum_ID:getForumID,
          Job_Advertisement_ID:getJobAdvID,
         Sort: sort,
         IsMobile: getIsMobile,
         Advertesing_Form_Link: values.link ? values.link.trim() : null,
         ...spanFields
        };
        dispatch(onUpdateCampain(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Advertesing_Form_CompanyName: values["title"],
          Advertesing_Category_ID: getCategoryID,
          Sort: sort,
          Advertesing_Form_Image: getFileName,
          Advertesing_Active: getIsActive,
          Advertesing_Form_Type : values["type"],

          News_ID:getNewsID,
          Forum_ID:getForumID,
          Job_Advertisement_ID:getJobAdvID,
          IsMobile: getIsMobile,
          Advertesing_Form_Link: values["link"] ? values["link"].trim() : null,
          ...spanFields

        };
        // save new user
        dispatch(onAddCampain(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.advertesingform,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);

  const [getJobAdvID, setJobAdvID] = useState(null);
  const [getForumID, setForumID] = useState(null);
  const [getNewsID, setNewsID] = useState(null);

  const [getNews, setNews] = useState([]);
  const [getForum, setForum] = useState([]);
  const [getJobAdv, setJobAdv] = useState([]);

  const [getIsMobile, setIsMobile] = useState(false);

  // Kategoriler panelden ID sirasiyla geliyor; kullanici numara sirasi bekliyor.
  // Rehberde olmayan (numarasiz) kategoriler listenin sonuna atilir.
  const sortedCategory = useMemo(() => {
    const withNo = (getCategory || []).map(item => {
      const slot = findSlot(AD_SYSTEM.FORM, item.Advertesing_Category_Title);
      return { item, no: slot ? slot.no : Number.MAX_SAFE_INTEGER };
    });
    withNo.sort((a, b) => a.no - b.no);
    return withNo.map(x => x.item);
  }, [getCategory]);

  // Formda secili olan alanin rehber kaydi (aciklama kutusu icin)
  const selectedSlot = useMemo(() => {
    const found = (getCategory || []).find(
      c => String(c.ID) === String(getCategoryID)
    );
    return found
      ? findSlot(AD_SYSTEM.FORM, found.Advertesing_Category_Title)
      : null;
  }, [getCategory, getCategoryID]);

  
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "ID",
        accessor: "ID",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        // Reklamin uygulamada NEREYE dustugunu tek bakista gosteren numara.
        // Kategori adlari ("BERLIN IS REHBERI") tek basina yeri anlatmadigi
        // icin her alana sabit bir numara verildi (bkz. helpers/adSlots.js).
        Header: "Alan No",
        id: "adSlotNo",
        disableFilters: true,
        accessor: row =>
          (row.Advertesing_Category &&
            row.Advertesing_Category.Advertesing_Category_Title) ||
          "",
        Cell: cellProps => {
          const slot = findSlot(AD_SYSTEM.FORM, cellProps.value);
          if (!slot) {
            return (
              <span
                className="badge badge-soft-danger font-size-11"
                title="Bu kategori rehberde tanımlı değil; reklam uygulamada görünmeyebilir."
              >
                ?
              </span>
            );
          }
          return (
            <div style={{ minWidth: 120 }}>
              <span
                className={
                  "badge font-size-12 " +
                  (slot.status === "off"
                    ? "badge-soft-secondary"
                    : "badge-soft-primary")
                }
              >
                {slotNoText(slot.no)}
              </span>
              <div className="text-muted font-size-11 mt-1">
                {slot.status === "off" ? "Kullanılmıyor" : slot.where}
              </div>
            </div>
          );
        },
      },

      {
        Header: "Sıra No",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Advertesing_Form_Image ? (
              <div className="avatar-xs">
                {cellProps.Advertesing_Form_CompanyName != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Advertesing_Form_CompanyName.charAt(0)}
                </span> : null}
              </div>
            ) : (
              cellProps.IsMobile == false ?  
              <div className="avatar-xl">
              <img
               className="avatar-xl"
                src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.Advertesing_Form_Image}
                alt=""
              />
            </div> :
              <div className="avatar-xl">
                <img
                 className="avatar-xl"
                  src={'https://berlinesnafapi.stechomeyazilim.com' + cellProps.Advertesing_Form_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Firma",
        accessor: "Advertesing_Form_CompanyName",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        // Basvurunun ne zaman geldigi listede gorunmuyordu
        Header: "Başvuru Tarihi",
        accessor: "Advertesing_Form_Created_Date",
        filterable: true,
        Cell: cellProps =>
          cellProps.value ? moment(cellProps.value).format("DD.MM.YYYY HH:mm") : "—",
      },

      {
        Header: "Kaynak",
        accessor: "IsMobile",
        filterable: true,
        Cell: cellProps => (
          <span className={"badge badge-soft-" + (cellProps.value ? "info" : "secondary")}>
            {cellProps.value ? "Mobil" : "Panel"}
          </span>
        ),
      },

      {
        Header: "Mail",
        accessor: "Advertesing_Form_MailAdress",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Telefon",
        accessor: "Advertesing_Phone",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Kategori",
        accessor: "Advertesing_Category.Advertesing_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
     
     
      {
        Header: "Yükseklik",
        accessor: row => `${readSpan(row)} kutucuk`,
        disableFilters: true,
        Cell: cellProps => (
          <span className="badge badge-soft-primary font-size-11">
            {cellProps.value}
            {isVideoType(readFileType(cellProps.row.original)) ? " · video" : ""}
          </span>
        ),
      },

      {
        Header: "Aktif Mi?",
        accessor: "Advertesing_Active",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },

      {
        // Reklama tiklaninca nereye gidildigi listede hic gorunmuyordu;
        // hedefi olmayan kayitlar (mobilde tiklanamayan reklamlar) burada
        // kirmizi rozetle isaretleniyor.
        Header: "Yönlendirme",
        accessor: "Advertesing_Form_Link",
        filterable: true,
        Cell: cellProps => {
          const t = describeAdvertTarget(cellProps.row.original);
          return (
            <div style={{ minWidth: 170 }}>
              <span className={`badge badge-soft-${t.color} font-size-11`}>{t.type}</span>
              {t.text ? (
                <div className="text-muted font-size-12 mt-1" style={{ wordBreak: "break-word" }}>
                  {t.href ? (
                    <a href={t.href} target="_blank" rel="noreferrer">{truncate(t.text, 46)}</a>
                  ) : truncate(t.text, 46)}
                </div>
              ) : null}
            </div>
          );
        },
      },

      {
        Header: "Forum",
        accessor: "Forum.Forum_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Haber",
        accessor: "News.News_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "İlan",
        accessor: "Job_Advertisement.Job_Advertisement_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    await axios.get(`${ODATA_BASE}/Advertesing_Category`)
      .then((res) => {
        setCategory(res.data.value || [])
      })


  }

 

  const _getJobAdvData = async () => {

    await axios.get(`${ODATA_BASE}/Job_Advertisement?$orderby=ID desc`)
      .then((res) => {
        setJobAdv(res.data.value || [])
      })
  }


  const _getNewsData = async () => {

    await axios.get(`${ODATA_BASE}/News?$orderby=ID desc`)
      .then((res) => {
        setNews(res.data.value || [])
      })
  }


  const _getForumData = async () => {

    await axios.get(`${ODATA_BASE}/Forum?$orderby=ID desc`)
      .then((res) => {
        setForum(res.data.value || [])
      })
  }


  useEffect(() => {
    _getJobAdvData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    _getNewsData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    _getForumData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu


  // API'de Advertesing_Form_Span kolonu olup olmadigini $metadata'dan ogreniyoruz.
  // (Kolon EDMX'e eklenip API yeniden yayinlandiginda otomatik aktif olur.)
  const _checkSpanSupport = async () => {
    try {
      const res = await axios.get(`${ODATA_BASE}/$metadata`, { responseType: "text" });
      setSpanSupported(String(res.data).includes('Name="Advertesing_Form_Span"'));
    } catch (e) {
      // Metadata okunamadi: yedek yol (UrlType icinde span:N) zaten yaziliyor
    }
  };

  useEffect(() => {
    _getAuthData()
    _checkSpanSupport()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu



  useEffect(() => {
    _getAuthData()
 

    if (users && !users.length) {
      dispatch(onGetCampain());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };




  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);
    setIsEdit(true);

    setCategoryID(user.Advertesing_Category_ID)

    setIsActive(user.Advertesing_Active)

    setFileName(user.Advertesing_Form_Image)
    setFileType(readFileType(user))
    setSpan(readSpan(user))
 
    setForumID(user.Forum_ID)
    setJobAdvID(user.Job_Advertisement_ID)
    setNewsID(user.News_ID)

    setIsMobile(user.IsMobile)
    toggle();
  };




  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteCampain(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    setFileName("");
    setFileType(null);
    setSpan(SPAN_DEFAULT);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const _addMedia = () => {


    getFileSubMediaAdd.map((item, index) => {
      const newUser = {
        Education_SubItem_ID: getSubMediaID,
        EducationSubItem_Media_Type: item.fileType,
        EducationSubItem_Media_Link: item.fileName
      }

      axios.post(API_BASE + '/addSubEducationMediaDiz/send', newUser)

      dispatch(onGetCampain());

      toggleMedia();
    })
  }

  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri


  const handleChangeStatus = ({ file, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)
          setFileType(file && file.type ? file.type : null)  // "image/png" / "video/mp4"
          setIsMobile(false)
        }
      }
    }
  }



  const _setChoiceNews = arg => {
    setNewsID(arg.target.value)
  }
  const _setChoiceForum = arg => {
    setForumID(arg.target.value)
  }

  const _setChoiceJobAdv = arg => {
    setJobAdvID(arg.target.value)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Reklam Alanları / Talepler" />
          <SayfaRehberi sayfa="advertesingform" />

          {/* "Bu reklami nereye koyacagiz" sorusunun cevabi: numarali alan listesi */}
          <div className="mb-3">
            <AdSlotGuide highlightSystem={AD_SYSTEM.FORM} />
          </div>

          {/* Yayindaki reklamlarin kacinin hedefi eksik — yonetici tek bakista gorsun */}
          {(() => {
            const active = (users || []).filter(u => u.Advertesing_Active);
            const missing = active.filter(
              u => describeAdvertTarget(u).type === "Yönlendirme yok"
            ).length;
            const invalid = active.filter(
              u => describeAdvertTarget(u).type === "Geçersiz tip"
            ).length;
            if (!missing && !invalid) return null;
            return (
              <div className="alert alert-warning py-2 font-size-13">
                <i className="bx bx-error-circle align-middle me-1" />
                Yayındaki <strong>{active.length}</strong> reklamdan{" "}
                {missing > 0 && (
                  <>
                    <strong>{missing}</strong> tanesinin yönlendirmesi yok
                    (tıklanınca hiçbir yere gitmiyor)
                  </>
                )}
                {missing > 0 && invalid > 0 && ", "}
                {invalid > 0 && (
                  <>
                    <strong>{invalid}</strong> tanesinin türü tanınmıyor
                  </>
                )}
                . İlgili kaydı düzenleyip &quot;Link&quot; alanını doldurabilir
                veya haber/forum/ilan seçebilirsiniz.
              </div>
            );
          })()}

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddAdvertesing={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

           
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Reklam Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>


                          <div className="mb-3">
                              <Label className="form-label">Haber Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getNewsID}
                                onChange={(text) => _setChoiceNews(text)}
                                value={
                                  getNewsID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getNews.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.News_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Forum Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getForumID}
                                onChange={(text) => _setChoiceForum(text)}
                                value={
                                  getForumID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getForum.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Forum_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">İlan Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getJobAdvID}
                                onChange={(text) => _setChoiceJobAdv(text)}
                                value={
                                  getJobAdvID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getJobAdv.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Job_Advertisement_Title}</option>
                                ))}

                              </Input>
                             
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">
                                Reklam Alanı Seçiniz (Alan No)
                              </Label>
                              <Input

                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {/* Alanlar numara sirasina gore listelenir; kategori
                                    adinin basindaki numara, reklamin uygulamada
                                    nereye dusecegini soyler. */}
                                {sortedCategory.map((item, index) => {
                                  const slot = findSlot(
                                    AD_SYSTEM.FORM,
                                    item.Advertesing_Category_Title
                                  );
                                  // <option> icine tek bir metin veriliyor;
                                  // parcali JSX cocuklari bazi tarayicilarda
                                  // araya bosluk katiyor.
                                  const label = slot
                                    ? `${slotNoText(slot.no)} · ${item.Advertesing_Category_Title} — ${slot.where}`
                                    : item.Advertesing_Category_Title;
                                  return (
                                    <option value={item.ID} key={item.ID}>
                                      {label}
                                    </option>
                                  );
                                })}

                              </Input>

                              {/* Secilen alanin uygulamada tam olarak nerede
                                  gorunecegi — "reklami nereye koyacagiz"
                                  sorusunun cevabi burada. */}
                              {selectedSlot ? (
                                <div
                                  className={
                                    "mt-2 p-2 rounded font-size-12 " +
                                    (selectedSlot.status === "off"
                                      ? "alert alert-danger mb-0"
                                      : "alert alert-info mb-0")
                                  }
                                >
                                  <div>
                                    <strong>
                                      Alan {slotNoText(selectedSlot.no)}
                                    </strong>{" "}
                                    — {selectedSlot.where}
                                  </div>
                                  {selectedSlot.screens &&
                                  selectedSlot.screens.length ? (
                                    <div className="mt-1">
                                      Göründüğü ekranlar:{" "}
                                      {selectedSlot.screens.join(", ")}
                                    </div>
                                  ) : null}
                                  <div className="mt-1">
                                    Gösterim: {selectedSlot.format}
                                  </div>
                                  {selectedSlot.note ? (
                                    <div className="mt-1">
                                      <strong>Dikkat:</strong> {selectedSlot.note}
                                    </div>
                                  ) : null}
                                </div>
                              ) : getCategoryID ? (
                                <div className="alert alert-warning mt-2 mb-0 font-size-12">
                                  Bu kategori rehberde tanımlı değil. Uygulamada
                                  karşılığı olmayabilir; kategori adı panelden
                                  değiştirilmiş olabilir.
                                </div>
                              ) : null}
                            </div>







                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Reklam Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Yönlendirme Linki</Label>
                              <Input
                                name="link"
                                label="link"
                                type="text"
                                placeholder="https://... (boş bırakılırsa aşağıdaki yönlendirme kullanılır)"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.link || ""}
                                invalid={
                                  validation.touched.link && validation.errors.link
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.link && validation.errors.link ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.link}
                                </FormFeedback>
                              ) : null}
                              <small className="text-muted">
                                Dolu ise reklama tıklayan kullanıcı bu adrese gider; haber/forum/ilan seçimi dikkate alınmaz.
                              </small>
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Türü (döviz · tatil · eczane · imsakiye · lotto · map · spor)</Label>
                              <Input
                                name="type"
                                label="type"
                                type="text"
                                placeholder="Reklam Türünü Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.type || ""}
                                invalid={
                                  validation.touched.type &&
                                    validation.errors.type
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.type &&
                                validation.errors.type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.type}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Yükseklik (reklam alanı)</Label>
                              <Input
                                type="select"
                                className="form-select"
                                value={getSpan}
                                onChange={(e) => setSpan(e.target.value)}
                              >
                                <option value="1">1 kutucuk (küçük banner ~120px)</option>
                                <option value="2">2 kutucuk (orta ~240px, varsayılan)</option>
                                <option value="3">3 kutucuk (büyük ~360px)</option>
                              </Input>
                              <small className="text-muted">
                                Reklam tam genişlikte gösterilir; bu ayar yüksekliği belirler.
                                {!spanSupported && " (API'de Advertesing_Form_Span kolonu henüz yok; değer geçici olarak dosya tipi alanında saklanıyor.)"}
                              </small>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Sıra No (gösterim sırası)</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                min="1"
                                placeholder="Örn: 1"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.sort === 0
                                    ? 0
                                    : validation.values.sort || ""
                                }
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                              <small className="text-muted d-block">
                                Küçük numara önce gösterilir. Bölüm içi ekranlarda
                                <strong> tek reklam</strong> gösterildiği için oraya
                                çıkmasını istediğiniz reklama <strong>1</strong> verin.
                                Boş bırakılırsa reklam, numarası olanların arkasında
                                (en yeni en üstte) sıralanır.
                              </small>
                            </div>


                            <div className="d-flex">
                              <label className="mb-0" htmlFor="sw-1">Aktif Mi?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="sw-1"
                                  className="switch"
                                  checked={!!(getIsActive)}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="sw-1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>




                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel / Video</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*,video/mp4,video/webm,video/ogg,image/gif"
                                />
                                <small className="text-muted">
                                  Resim ya da video yükleyebilirsiniz (mp4/webm/ogg).
                                </small>

                              </Col>
                            </div>

                           {!getFileName ? null : isVideoType(getFileType) ? (
                              <video className="avatar-md" controls>
                                <source
                                  src={(getIsMobile == false
                                    ? 'https://megasubdomain.stechomeyazilim.info/'
                                    : 'https://berlinesnafapi.stechomeyazilim.com') + getFileName}
                                  type={getFileType}
                                />
                              </video>
                            ) : (
                              <div>
                                <img
                                  src={(getIsMobile == false
                                    ? 'https://megasubdomain.stechomeyazilim.info/'
                                    : 'https://berlinesnafapi.stechomeyazilim.com') + getFileName}
                                  alt=""
                                  className="avatar-md"
                                />
                              </div>
                            )}







                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
